module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point4_4-0a80dd5d65c11a7b0b4d9a46d479184b.jpg";